// upload
export const API_UPLOAD = '/upload';

// auth
export const API_LOGIN = '/login';
export const API_GET_LOGIN_USER = '';

// revenue
export const API_GET_PRIZE_STATS = '/prize-stats';
export const API_GET_PRIZE_STATS_TRACKING = '/prize-stats/tracking';
export const API_GET_TRACKING_DETAIL = '/prize-stats/tracking-pieces';
export const API_GET_LOGIN_STATS = '/login-stats';
export const API_GET_REGISTER_REPORT = '/report/register';
export const API_GET_REVENUE_REPORT = '/report/revenue';
export const API_GET_PIECE_STATS = '/piece-stats';
export const API_GET_GAME_STATS = '/game-stats';
// topics
export const API_GET_TOPICS = '/topic';
export const API_CREATE_TOPIC = '/topic/create';
export const API_UPDATE_TOPIC = '/topic/edit';

// topics answer
export const API_GET_TOPICS_ANSWER = '/topic-answer';
export const API_CREATE_TOPICS_ANSWER = '/topic-answer/create';
export const API_UPDATE_TOPIC_ANSWER = '/topic-answer/edit';
export const API_DELETE_TOPIC_ANSWER = '/topic-answer/delete';

// block msisdn
export const API_GET_BLOCK_MSISDN = '/block-isdn';
export const API_CREATE_BLOCK_MSISDN = '/block-isdn';

// wheel
export const API_GET_WHEEL = '/award-wheel';
export const API_UPDATE_WHEEL = '/award-wheel/edit';

// prize management
export const API_GET_PRIZE_MANAGEMENT = '/prize-management';
export const API_CREATE_PRIZE_MANAGEMENT = '/prize-management/create';
export const API_UPDATE_PRIZE_MANAGEMENT = '/prize-management/edit';
export const API_CLONE_PRIZE_MANAGEMENT = '/prize-management/clone';

// piece
export const API_GET_PIECE = '/piece';
export const API_UPDATE_PIECE = '/piece/edit';
export const API_CREATE_PIECE = '/piece/create';
export const API_DELETE_PIECE = '/piece/delete';

// mission
export const API_GET_MISSION = '/mission';
export const API_CREATE_MISSION = '/mission/create';
export const API_UPDATE_MISSION = '/mission/update';
export const API_REPORT_MISSION = '/mission/report';

// customer care
export const API_GET_SOLO_MODE = '/history-solo-mode';
export const API_GET_MULTI_MODE = '/history-multi-mode';
export const API_GET_FREE_PLAY = '/free-play';
export const API_GET_CHARGE_HISTORY = '/charge-history';
export const API_GET_REGISTER_CANCEL = '/register-cancel';
export const API_GET_USER_KEY = '/lucky-box/user';

// send sms
export const API_GET_SEND_SMS_OVERVIEW = '/send-sms/overview';
export const API_GET_SEND_SMS_DETAIL = '/send-sms/detail';
export const API_CREATE_SEND_SMS = '/send-sms/create';
export const API_POST_RESEND_SMS = '/send-sms/resend';

// config
export const API_GET_CONFIG = '/config';
export const API_UPDATE_CONFIG_GENERAL = '/config/edit-general';
export const API_UPDATE_CONFIG_INFO = '/config/edit-info';
export const API_UPDATE_CONFIG_SMS = '/config/change-sms-config';
export const API_GET_CHAR_CORE = '/config/get-char-core';
export const API_UPDATE_DAILY_QUEST_BY_HEART = '/config/edit-daily-quest-by-heart';
export const API_UPDATE_CONFIG_MESSAGE_BAR = '/config/edit-message-bar';
export const API_UPDATE_EVENT_PROMOTION = '/config/edit-event-promotion';

// seven days login
export const API_SEVEN_DAYS_LOGIN = `/seven-days-login`;
export const API_MISSION_DAILY_REWARD = `/seven-days-login/mission-daily-reward`;

// luck-box
export const API_REPORT_OPEN_BOX = `/lucky-box/report`;
export const API_GET_BOX = `/lucky-box`;
export const API_UPDATE_BOX = `/lucky-box/update`;

//Theme Management
export const API_THEMES = `/themes`;
export const API_THEMES_DEFAULT_ITEMS = `/themes/default/items`;

